import { Box, CircularProgress } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import {
  useGetQuotationAllowedActions,
  useShowQuotation,
} from "../../../../../__generated__/orval/endpoints/quotations/quotations";
import { QuotationDetails } from "./-internal_components/QuotationDetails";

const RouteComponent: FC = () => {
  const { quotationId } = Route.useParams();

  const { data: quotation, isLoading: isLoadingQuotation } = useShowQuotation(
    Number(quotationId),
  );
  const { data: availableActions, isLoading: isLoadingAvailableActions } =
    useGetQuotationAllowedActions(Number(quotationId));

  if (
    isLoadingQuotation ||
    isLoadingAvailableActions ||
    !quotation ||
    !availableActions
  ) {
    return (
      <Box
        sx={{ alignItems: "center", display: "flex", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <QuotationDetails
      availableActions={availableActions}
      quotation={quotation}
    />
  );
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId/details",
)({
  component: RouteComponent,
});
